/**
 * Created by andrey on 01.08.2022
 */

const SaveFinalResultsAction = function (f) {
    const game = Game.currentGame;
    const level = game.level;
    const outcome = game.outcome;

    if (outcome === GameBase.OUTCOME_VICTORY && level.isDailyCup()) {
        cleverapps.dailyCup.addAmount(game.getDailyCupStars());
        cleverapps.dailyCup.reload(true);
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.CUP_PLAYERS + cleverapps.dailyCup.type);
        cleverapps.eventBus.trigger("taskEvent", "PASS_DAILY_CUP_LEVEL");
        cleverapps.eventBus.trigger("pass_dailycup_level");
    }

    if (outcome === GameBase.OUTCOME_VICTORY && cleverapps.config.type === "match3") {
        if (!cleverapps.user.isPlayingFakeLevels()) {
            const levelNo = level.getHumanReadableNumber();
            cleverapps.activities.send(Activities.TYPES.LVL_PASSED, {
                userName: cleverapps.user.getPlayerInfo().name,
                score: game.score.getPoints(),
                levelNo
            });
        }

        if (level.isRegular() && cleverapps.exp.isAvailable() && !game.rewards[GameBase.REWARD_EXP] && !game.bonusLevelCounter) {
            game.rewards[GameBase.REWARD_EXP] = level.isHard() ? GameBase.HARD_LEVEL_EXP_PRIZE : GameBase.EXP_PRIZE;
        }

        if (cleverapps.starChest && cleverapps.starChest.isEnabled() && (level.isRegular() || level.isDailyCup())) {
            game.rewards.stars = game.score.stars;
        }

        if (level.isRegular()) {
            const statsParams = game.getLevelStatsParams();
            statsParams.value = game.score.stars;

            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_STARS, statsParams);
        }
    }

    if (game.rewards[GameBase.REWARD_BOOSTERS]) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.BOOSTER_CELL_RECEIVED);
    }

    if (level.isRegular()) {
        if (outcome === GameBase.OUTCOME_VICTORY) {
            cleverapps.eventBus.trigger("taskEvent", "PASS_LEVEL", { level: level.getHumanReadableNumber() });
            cleverapps.eventBus.trigger("pass_level", level.isHard());

            if (level.isHard()) {
                cleverapps.eventBus.trigger("taskEvent", "PASS_LEVEL_HARD");
                cleverapps.eventBus.trigger("pass_hardlevel");
            }
        }

        if (outcome === GameBase.OUTCOME_VICTORY) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.META_LEVEL);
        }
        cleverapps.eventBus.trigger("outcome", outcome);

        cleverapps.meta.getSelectedLocation().gamePlayed(game);

        cleverapps.missionManager.getRunningMissions().forEach((mission) => {
            mission.gamePlayed(game, level);
        });
    }

    if (cleverapps.config.type === "tile3") {
        cleverapps.eventBus.trigger("taskEvent", "COLLECT_TILES", game.collectedTiles);
    }

    if (cleverapps.config.type === "blocks") {
        if (game.getMode() === GameBase.MODE_HIGHSCORE) {
            cleverapps.eventBus.trigger("taskEvent", "SCORE_POINTS", game.score.points);
        }
        cleverapps.eventBus.trigger("taskEvent", "EXPLODE_LINES", game.explodedLines);
    }

    if (cleverapps.config.type === "yatzy") {
        if (outcome === GameBase.OUTCOME_VICTORY) {
            if (game.score.points >= 250) {
                cleverapps.eventBus.trigger("taskEvent", "GET_HIGH_SCORE");
            }

            if (game.score.points >= 150) {
                cleverapps.eventBus.trigger("taskEvent", "GET_SCORE");
            }
        }
    }

    if (cleverapps.config.type === "colorsort") {
        if (outcome === GameBase.OUTCOME_VICTORY) {
            if (!game.prolongationUsed) {
                cleverapps.eventBus.trigger("taskEvent", "PASS_LEVEL_WITHOUT_PROLONGATION");
            }

            if (game.endAt && game.endAt > game.startAt && (game.endAt - game.startAt) < 60000) {
                cleverapps.eventBus.trigger("taskEvent", "PASS_LEVEL_FAST");
            }
        }
    }

    if (outcome === GameBase.OUTCOME_LOST && game.timer.getTime() < GameBase.QUICK_LOSE_TIMEOUT) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_QUICK_LOSE, game.getLevelStatsParams());
    }

    cleverapps.restoreProgress.update();

    f();
};
